import { CampaignType, SipTransport, TrunkType } from '@shared/services/apiService/apiService';

export const CampaignTypeEnum: Record<Uppercase<CampaignType>, CampaignType> = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
} as const;

export const SocketMessageEvents = {
  GET_CALLS: 'get_calls',
  SUB_TO_GET_CALLS: 'subscribe_to_get_calls',
} as const;

export const ToolTypeEnum = {
  EndCall: 'end-call',
  RequestCallback: 'request-callback',
  VoiceMailDetection: 'voice-mail-detection',
  WhatsappMessageSend: 'whatsapp-message-send',
  GenerateWhatsappMessage: 'generate-whatsapp-message',
  TransferCall: 'transfer-call',
  Mcp: 'mcp',
  CallHandoffSignal: 'call-handoff-signal',
  GenderDetection: 'gender-detection',
} as const;

export const SipTransportEnum: Record<Uppercase<SipTransport>, SipTransport> = {
  AUTO: 'auto',
  TCP: 'tcp',
  TLS: 'tls',
  UDP: 'udp',
} as const;

export const SipTrunkType: Record<Uppercase<TrunkType>, TrunkType> = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
} as const;
